import { AccordionSummary, styled } from '@mui/material';

export const StyledAccordionSummary = styled(AccordionSummary)`
  background-color: transparent;
  padding: 16px 20px 16px 0;

  &.MuiAccordionSummary-root {
    min-height: unset;
    flex-direction: row-reverse;
    gap: 8px;
    flex: 1;
  }

  .MuiAccordionSummary-content {
    align-items: center;
  }
`;
